// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k50Z","title":"styles_title__2gQiS"};